/**
 * Nominatim addresstype / place_rank filtering for building geocoding.
 *
 * place_rank scale (address hierarchy):
 *   4        country
 *   5-9      state
 *   10-12    county
 *   13-16    city
 *   17-21    suburb
 *   22-24    neighbourhood
 *   25       locality / postcode area
 *   26-27    street
 *   28-30    house / POI
 *
 * @see https://nominatim.org/release-docs/latest/customize/Ranking/
 */

export type NominatimSearchItem = Record<string, unknown>;

export const MIN_RELEVANT_PLACE_RANK = 28;

export const isRelevantNominatimPlace = (item: NominatimSearchItem) => {
  const placeRank = Number(item.place_rank);

  if (Number.isFinite(placeRank)) return placeRank >= MIN_RELEVANT_PLACE_RANK;

  const address = item.address as Record<string, unknown> | undefined;
  return Boolean(address?.house_number || address?.road);
};

export const findFirstRelevantNominatimResult = (data: unknown): NominatimSearchItem | null => {
  if (!Array.isArray(data) || !data.length || !data?.[0]) return null;
  return data.find((item) => isRelevantNominatimPlace(item as NominatimSearchItem)) ?? null;
};
